import axios from "axios";
import { StandardAxiosConfig, getBaseDataURL, parseDates } from "../../../common";
import { BaseDataModel } from "../../../types/dataModels";

export class CreateAPI_Base<T extends BaseDataModel> {
	private router: string;
	protected baseUrl: string;

	constructor(router: string) {
		this.router = router;
		this.baseUrl = `${getBaseDataURL(router)}/create`;
	}

	async many(records: Partial<T>[]): Promise<T[]> {
		const url = this.baseUrl;

		const response = await axios.post(url, records, StandardAxiosConfig());
		if (response.status != 200) {
			throw new Error(`Create failed for ${this.router}: ${response.statusText}`);
		}
		const createdRecords = response.data as T[];
		parseDates<T>(createdRecords);
		return createdRecords;
	}

	async one(data: Partial<T>): Promise<T> {
		return (await this.many([data]))[0];
	}
}
